import { OPEN_MODAL, CLOSE_MODAL } from 'actionTypes';

export function openModal(modalName, modalProps) {
  return {
    type: OPEN_MODAL,
    modal: {
      name: modalName,
      props: modalProps,
    },
  };
}

export function closeModal() {
  return {
    type: CLOSE_MODAL,
  };
}



// WEBPACK FOOTER //
// ./src/actions/modalActions.js